<app-dialog-header [title]="titleKey" (onClick)="dialogRef.close(false)"></app-dialog-header>

<div mat-dialog-content class="p-24 copy-to-existing-dialog-content" fxLayout="column" fxLayoutAlign="start">
    <app-allowed-modules-list
        [currentModule]="currentModule"
        [allowedKinds]="allowedKinds"
        (choosenModule)="saveSelectedModule($event)"
    ></app-allowed-modules-list>
</div>
<div mat-dialog-actions class="pt-24 action-buttons" fxLayout="row" fxLayoutAlign="end center">
    <app-white-button class="mr-8" [label]="'GENERAL.BUTTON.CANCEL'" (onClick)="dialogRef.close(false)"></app-white-button>
    <app-flat-button [label]="actionButtonKey" (onClick)="copyModule()" [disabled]="!selectedModule"></app-flat-button>
</div>
